import VueSweetalert from 'vue-sweetalert2'

const swalOptions = {
  width: 400,
  buttonsStyling: false,
  cancelButtonText: 'Отмена',
}

export { VueSweetalert, swalOptions }
